module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow3-waso-16ab17b19a92e63a811c6fef07c470fb.jpg";